import type { UploadedFile } from "../schema/UploadedFile.js";
import type { UploadedFileBucket } from "../schema/UploadedFileBucket.js";

export function getUploadedFilePath(
	uploadedFile: UploadedFile,
	bucketUrlMap: Record<UploadedFileBucket, string>,
): string {
	return `${bucketUrlMap[uploadedFile.bucket]}/${uploadedFile.path}`;
}
